import React from 'react';
import HighlightedBlock from '../highlightedBlock';

export default function InfoBlock(props) {
	return <HighlightedBlock color='black' bgColor='rgba(38, 38, 38, 0.2)' {...props} />;
}
